try {
  const intersectionObserver = new IntersectionObserver(function (entries) {
    entries.forEach((entrie) => {
      if (entrie.isIntersecting) {
        const target = entrie.target as HTMLImageElement
        target.src = target.getAttribute('data-src') as string
        target.removeAttribute('data-src')
        intersectionObserver.unobserve(entrie.target)
      }
    })
  })

  // eslint-disable-next-line no-inner-declarations
  function _getImg() {
    const layzloadImg = document.querySelectorAll('img[data-layzload-src]')
    layzloadImg.forEach((img) => {
      img.setAttribute('data-src', img.getAttribute('data-layzload-src') as string)
      img.removeAttribute('data-layzload-src')
      intersectionObserver.observe(img)
    })
  }
  _getImg()
  setInterval(_getImg, 1000)
} catch (error) {
  console.log(error, 'error')
}

export {}
